module.exports = __webpack_public_path__ + "img/p6.6652d2d5.png";